import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class IsPasswordNotBlacklisted {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * isPasswordNotBlacklisted constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Check if requested password is not blacklisted.
     *
     * @param {String} password
     *
     * @returns {Promise}
     */
    handle(password) {
        return this.apiService
            .post(ApiEndpoints['blacklisted-passwords'], {
                password: password,
            });
    }
}
